import {createReducer, on} from '@ngrx/store';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';
import {
  clearDeleteStreamConfigurationState,
  deleteStreamConfiguration,
  deleteStreamConfigurationFailure,
  deleteStreamConfigurationSuccess
} from './stream-configuration.delete.actions';


export interface State {
  record: StreamConfiguration | null;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteStreamConfigurationReducer = createReducer(
  initialState,

  on(deleteStreamConfiguration, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteStreamConfigurationSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteStreamConfigurationFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteStreamConfigurationState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

